/**
 * LO QUE SALIO MAL, EN CASTELLANO. Una sola traduccion para toda la app.
 *
 * Antes habia dos copias de esta funcion —una en `usePuente.ts` y otra en `useGobierno.ts`— con
 * listas de casos DISTINTAS: la del puente sabia de gas insuficiente y de la base fee, la del
 * gobierno sabia de red equivocada y de los errores del timelock, y cada una dejaba en crudo lo
 * que la otra traducia. El usuario veia un volcado de viem por no haber pasado por el fichero
 * correcto.
 *
 * Los mensajes de wallet y de red van primero porque son los que le pasan a todo el mundo; los
 * errores propios de un contrato van despues y no estorban a nadie que no los use.
 */
export function traducir(e: unknown, ctx?: { moneda?: string; red?: string }): string {
  const t = e instanceof Error ? e.message : String(e);

  // --- wallet y red: le pasan a cualquiera, en cualquier pantalla
  if (/User rejected|denied transaction|4001/i.test(t)) return "Cancelaste la firma en tu wallet.";
  if (/does not match|chain mismatch|ChainMismatch/i.test(t))
    return "Tu wallet está en otra red. Acepta el cambio de red que te pide MetaMask y vuelve a intentarlo.";
  // EL GAS SE PAGA EN LA CADENA DE ORIGEN, y en una pantalla con dos cadenas a la vista eso no se
  // deduce: «el nativo de esta cadena» no dice cual de las dos ni que moneda es. Mandando USDG de
  // Robinhood a BNB Chain hace falta ETH en Robinhood — no BNB, que es lo que uno mira porque es lo
  // que esta comprando. Con `ctx` el mensaje lo dice con nombre y apellido.
  if (/insufficient funds/i.test(t)) {
    return ctx?.moneda && ctx?.red
      ? `Necesitas ${ctx.moneda} en ${ctx.red} para pagar el gas: el gas se paga siempre en la red desde la que envías, no en la de destino.`
      : "No te alcanza el nativo para pagar el gas de la red desde la que envías.";
  }
  if (/max fee per gas less than block base fee/i.test(t))
    return "La red subió el precio del gas mientras firmabas. Vuelve a intentarlo.";

  // --- KeelTimelock: los errores del gobierno, con el nombre que revierte el contrato
  if (/NoOwner/.test(t)) return "Esa wallet no es la dueña del timelock.";
  if (/YaEncolada/.test(t)) return "Ya hay una propuesta viva con esos mismos datos.";
  if (/NoEncolada/.test(t))
    return "No hay nada encolado con esos datos. Revisa que las direcciones sean IDÉNTICAS a las que anunciaste.";
  if (/Pronto/.test(t)) return "Todavía no ha pasado el retardo. Falta esperar.";
  if (/Caducada/.test(t)) return "La propuesta caducó: hay que volver a encolarla.";

  // Solo la primera linea: viem pega el request entero debajo y no se lee.
  return t.split("\n")[0] ?? t;
}
